import { api } from "@/modules/api";

export const prepareAudioRecordingDownloadUrl = async ({
  audioRecordingId,
}: {
  audioRecordingId: string;
}): Promise<string> => {
  const response = await api.post("/v2/audio-recordings/{audio_recording_id}/prepare-download", {
    params: {
      path: { audio_recording_id: audioRecordingId },
    },
  });

  if (response.error || !response.data?.download_url) {
    throw new Error("Failed to prepare audio recording download URL");
  }

  return response.data.download_url;
};
